import { useGoogleTagManager, useMixpanel, useSentry } from '@/vendors/integrations'

export function useTrackingProject () {
  const gtm = useGoogleTagManager()
  const mixpanel = useMixpanel()
  const { withErrorHandler } = useSentry()

  const trackProjectCreated = ({ procedure, project, transaction }) => {
    withErrorHandler(() => {
      mixpanel.track('New project', {
        ...procedure.to_mixpanel,
        ...project.to_mixpanel
      })

      gtm.track({
        event: 'project_created',
        ...project.to_gtm,
        ecommerce: {
          ...transaction?.to_gtm
        }
      })

      gtm.reset()
    })
  }

  const trackProjectMemberJoined = ({ accept_invite, transaction }) => {
    withErrorHandler(() => {
      mixpanel.track(`User joined ${accept_invite.target_type.toLowerCase()}`, accept_invite.to_mixpanel)

      gtm.track({
        event: 'project_member_joined',
        ...accept_invite.to_gtm,
        ecommerce: {
          ...transaction?.to_gtm
        }
      })

      gtm.reset()
    })
  }

  const trackProjectDeleted = ({ project }) => {
    withErrorHandler(() => {
      mixpanel.track('Delete project', {
        ...project.to_mixpanel,
        'Status': 'Deleted'
      })

      gtm.track({
        event: 'project_deleted',
        ...project.to_gtm,
        project_status: 'deleted'
      })
    })
  }

  return {
    trackProjectCreated,
    trackProjectMemberJoined,
    trackProjectDeleted
  }
}
